import { Injectable } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MonitoringPageService {
  matDrawer$ = new BehaviorSubject<MatDrawer>(null);

  close(): void {
    this.matDrawer$.getValue().close();
    this.matDrawer$.next(this.matDrawer$.getValue());
  }
}
